import useFetchList from '../../../elements/Hooks/useFetchList'
import useFetchObject from '../../../elements/Hooks/useFetchObject'
import useModalData from '../../../elements/Hooks/useModalData'
import { isEmpty } from 'lodash'
import { handleResponse } from '../../../modules/Utils'
import { withRouter } from 'react-router-dom'
import React from 'react'
import Subsidiary from '../../../components/Corporate/Subsidiary/Subsidiary'
import Subsidiaries from '../../../api/Subsidiaries'
import Members from '../../../api/Members'

const api = new Subsidiaries()
const memberApi = new Members()

function SubsidiaryCont(props) {
  const key = props.match.params.key
  const { fetch: fetchMember, fetching: memberFetching, object: member } = useFetchObject(() =>
    memberApi.get(key).then(handleResponse)
  )

  const {
    fetch: fetchSubsidiary,
    fetching: subsidiaryFetching,
    object: subsidiary,
  } = useFetchObject(() => api.getMember(key))

  console.log(12, { subsidiary })
  const { fetch: fetchRepsList, fetching: repsListFetching, object: repsList } = useFetchList(
    () => memberApi.representatives.list(member._key).then(handleResponse),
    false,
    [member],
    isEmpty(member._key)
  )

  function fetch() {
    fetchMember()
    fetchSubsidiary()
    fetchRepsList()
  }

  const { visible, formRef, onShow: onEdit, onCancel, update, submitting } = useModalData(
    undefined,
    api.update,
    undefined,
    fetch
  )

  return (
    <Subsidiary
      {...{
        fetch,
        onEdit,
        onCancel,
        update,
        formRef,
        member,
        subsidiary,
        repsList,
        fetchMember,
        memberFetching,
        subsidiaryFetching,
        repsListFetching,
        visible,
        submitting,
      }}
    />
  )
}

SubsidiaryCont.propTypes = {}
SubsidiaryCont.defaultProps = {}

export default withRouter(SubsidiaryCont)
